module.exports = __webpack_public_path__ + "static/media/Thebes.2500b00f.jpg";